<template>
  <div>
    <div class="d-start-start mb-3 mt-4">
      <left-text leftText="营业执照"/>
      <upload-image  :existImgs="priceArrs.certpic" :maxLength="1"/>
    </div>
    <div class="d-flex mb-3"><left-text leftText="名称"/>{{priceArrs.title||'暂无'}}</div>
    <div class="d-flex mb-3"><left-text leftText="地址"/>{{pcd()}}</div> 
    <div class="d-flex mb-3"><left-text leftText="详细地址"/>{{priceArrs.address||'暂无'}}</div> 
    <div class="d-flex mb-3"><left-text leftText="修改原因"/>{{priceArrs.reason||'暂无'}}</div>     
  </div>
</template>

<script>
export default {
  props:['priceArrs'],
  methods: {
    pcd(){
      return  this.priceArrs.province_name + '省、' + this.priceArrs.city_name + '市、' + this.priceArrs.district_name||'暂无'
    },
  },
}
</script>

<style>

</style>